import React from 'react';
import { Checkbox, Flex } from 'antd';
import styled from 'styled-components';
import { Icon } from '@synergy/icons';
import { Text, Spinner } from '@synergy/atomics_and_hooks';
import Theme from '../../../styles/Theme/Theme';

const CheckboxItemWrapper = styled(Flex)`
    width: 100%;
    padding-bottom: ${Theme.spacing['s03']};
    border-bottom: ${props => props.$expanded ? 'none' : '1px solid #C2C2C2'};

    .ant-checkbox-wrapper {
        flex: 1;

        .ant-checkbox {
            border-radius: 4px;

            .ant-checkbox-inner {
                border-radius: 4px;
                border-color: ${Theme.color['blue-4']};
            }

            &.ant-checkbox-checked .ant-checkbox-inner {
                background-color: ${Theme.color['blue-4']};
                border-color: ${Theme.color['blue-4']};
            }
        }
    }

    .chevron-button {
        display: flex;
        align-items: center;
        justify-content: center;
        transition: transform 0.2s ease;
        cursor: pointer;
    }

    .badge {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        min-width: 20px;
        height: 20px;
        padding: 0 6px;
        border-radius: 8px;
        font-size: ${Theme.typography.fontSize['text_xs_desktop']};
        font-weight: 500;
        color: ${Theme.color['white']};

        &.badge-orange {
            background-color: #DEAA6C;
        }

        &.badge-blue {
            background-color: #73A5C2;
        }

        &.badge-red {
            background-color: #DA6E70;
        }
    }
`;

/**
 * FilterCheckboxItem - A labeled checkbox row with optional badges and a collapse chevron.
 *
 * @param {boolean}    checked        - Whether the checkbox is checked
 * @param {Function}   onChange       - Checkbox toggle callback
 * @param {string}     label          - Checkbox label text
 * @param {boolean}    expanded       - Whether the section below is expanded
 * @param {Function}   onToggle       - Chevron click callback to expand/collapse
 * @param {Array}      badges         - Array of { count, variant } — variant: 'red' | 'orange' | 'blue'
 * @param {boolean}    loading        - When true, shows a spinner instead of badges and chevron
 * @param {boolean}    expandable     - When false, hides the chevron (no expandable section). Default: true
 */
export const FilterCheckboxItem = ({ checked, onChange, label, expanded, onToggle, badges = [], loading = false, expandable = true }) => {
    return (
        <CheckboxItemWrapper align="center" justify="space-between" $expanded={expanded}>
            <Checkbox checked={checked} onChange={onChange}>
                <Text textcolor='coolgray-12' textsize='text_sm' textweight='regular'>
                    {label}
                </Text>
            </Checkbox>
            {loading ? (
                <Spinner stroke="blue-4" size='18px' />
            ) : (
                <Flex gap={4}>
                    {badges.map((badge, i) => (
                        <span key={i} className={`badge badge-${badge.variant}`}>
                            {badge.count}
                        </span>
                    ))}
                    {expandable ? (
                        <div className="chevron-button" onClick={onToggle}>
                            <Icon
                                iconsize={'xs'}
                                icon={expanded ? 'ChevronUp' : 'ChevronDown'}
                                color={'coolgray-8'}
                            />
                        </div>
                    ) : null}
                </Flex>
            )}
        </CheckboxItemWrapper>
    );
};
